import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Collapse, List, ListItemButton, ListItemText } from '@mui/material';
import { ReactNode, useCallback, useId, useMemo, useState } from 'react';

interface NestedSelectItemProps {
  label: string;
  children?: ReactNode;
  depth?: number;
}

export default function NestedSelectItem({
  label,
  children,
  depth = 0,
}: NestedSelectItemProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const collapseId = useId();

  const handleToggle = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded((prev) => !prev);
  }, []);

  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  const listItemSx = useMemo(
    () => ({
      display: 'flex',
      justifyContent: 'space-between',
      py: 0.75,
      pl: 2 + depth * 2,
      pr: 2,
      '&.Mui-selected': { backgroundColor: 'transparent' },
      '&.Mui-selected:hover': { backgroundColor: 'action.hover' },
    }),
    [depth],
  );

  const ExpandIcon = isExpanded ? ExpandLess : ExpandMore;

  return (
    <>
      <ListItemButton
        onMouseDown={handleMouseDown}
        onClick={handleToggle}
        sx={listItemSx}
        aria-expanded={isExpanded}
        aria-controls={collapseId}
      >
        <ListItemText primary={label} />
        <ExpandIcon />
      </ListItemButton>
      <Collapse in={isExpanded} timeout='auto' unmountOnExit>
        <List component='div' disablePadding id={collapseId}>
          {children}
        </List>
      </Collapse>
    </>
  );
}
